module.exports = __webpack_public_path__ + "img/placeholder.727d3703.gif";